import { Security } from "./types";
import fetchWrapper from "src/utils/fetchWrapper";

// Ingress-security lists (the Security tab): CrowdSec IP bans (blacklist) + allowlist,
// proxied by the admin-service at /admin/security/*. Reads set redux state; mutations are
// staged in the view and applied on confirm, each carrying the per-IP reason (in the body)
// and the confirmation reason (x-reason header, one per applied change -> the audit trail).
const base = (getState) => getState().Auth.adminServiceUrl + "/security";

export const SecurityActions = {
    FetchBans: () => async (dispatch, getState) => {
        try {
            const resp = await dispatch(fetchWrapper(base(getState) + "/bans"));
            dispatch({ type: Security.SET_BANS, bans: (resp && resp.bans) || [] });
        } catch (e) {
            dispatch({ type: Security.SET_ERROR, error: String(e) });
        }
    },

    FetchAllowlist: () => async (dispatch, getState) => {
        try {
            const resp = await dispatch(fetchWrapper(base(getState) + "/allowlist"));
            dispatch({ type: Security.SET_ALLOWLIST, entries: (resp && resp.entries) || [] });
        } catch (e) {
            dispatch({ type: Security.SET_ERROR, error: String(e) });
        }
    },

    // Mutations return the request promise (no auto-refetch); the view awaits them
    // during confirm and refreshes once. `auditReason` is the confirmation reason.
    AddBan: (ip, duration, ipReason, auditReason) => (dispatch, getState) =>
        dispatch(
            fetchWrapper(base(getState) + "/bans", {
                method: "POST",
                headers: { "x-reason": auditReason || "" },
                body: JSON.stringify({ ip, duration, reason: ipReason }),
            })
        ),

    RemoveBan: (ip, auditReason) => (dispatch, getState) =>
        dispatch(
            fetchWrapper(base(getState) + "/bans?ip=" + encodeURIComponent(ip), {
                method: "DELETE",
                headers: { "x-reason": auditReason || "" },
            })
        ),

    AddAllowlistEntry: (ip, ipReason, ttl, auditReason) => (dispatch, getState) =>
        dispatch(
            fetchWrapper(base(getState) + "/allowlist", {
                method: "POST",
                headers: { "x-reason": auditReason || "" },
                body: JSON.stringify({ ip, reason: ipReason, ttl }),
            })
        ),

    RemoveAllowlistEntry: (ip, auditReason) => (dispatch, getState) =>
        dispatch(
            fetchWrapper(base(getState) + "/allowlist?ip=" + encodeURIComponent(ip), {
                method: "DELETE",
                headers: { "x-reason": auditReason || "" },
            })
        ),
};
